module.exports = "div.card {\n  margin-bottom: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/nomina/simulador/nomina-simulador.component.scss
// module id = ./src/app/creditos/nomina/simulador/nomina-simulador.component.scss
// module chunks = main